import React from "react";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import { Button } from "@abb/abb-common-ux-react";
import AssociateCalculatedProperty from "../../components/grade/AssociateCalculatedProperty";
import {
    ICalculatedPropertyViewData,
} from "../../models/property/CalculatedPropertyViewData";

interface IFormulaDefinitionTableProps {
    optionRef: any;
    onCloseAll: (e: any) => void;
    onToggleClick: (data: any, index: number, i: number, calculatedId: string) => void;
    valueList: any[];
    calculatedPropertyDetails: ICalculatedPropertyViewData[];
    readingSourceList: any[];
    oldPartitionName: any[];
    readingValuesList: any[];
    partitionName: any[];
    onSourceChangeHandler: (data: any, index: number, i: number, calculatedId: string) => void;
    onValuesChangeHandler: (data: any, index: number, i: number, calculatedId: string) => void;
    onPartitionChangeHandler: (data: any, index: number, i: number, calculatedId: string, selectedElement: any) => void;
    disableValueDropdown: boolean;
    disablePositionDropdown: boolean;
    disableSourceDropdown: boolean;
    onEditPartitionChange: (data: any, index: number, i: number, calculatedId: string) => void;
    thresholdvalue: any;
    showGrade?: boolean;
    componentType?: string;
    instrumentPartitions?: any[];
    keyedInPartitions?: any[];
    measuredProperty?: any[];
}

export default class FormulaDefinitionTable extends React.Component<IFormulaDefinitionTableProps, {}> {
    private _mount: boolean = false;

    constructor(props: IFormulaDefinitionTableProps) {
        super(props);
        this._mount = true;
    }

    componentWillUnmount() {
        this._mount = false;
    }

    componentDidMount() {
        this._mount = true;
    }

    public render() {
        return (
            <Translation>
                {(t) => (
                    <React.Fragment>
                        <div className="ml-3 w-100">
                            {this.props.showGrade && <hr className="hr-line mt-4" />}
                            <AssociateCalculatedProperty
                                optionRef={this.props.optionRef}
                                onCloseAll={(value) => this.props.onCloseAll(value)}
                                onToggleClick={(value, index, i, calculatedId) =>
                                    this.props.onToggleClick(value, index, i, calculatedId)
                                }
                                newList={this.props.valueList}
                                details={this.props.calculatedPropertyDetails}
                                sourceList={this.props.readingSourceList}
                                oldPartitionList={this.props.oldPartitionName}
                                valuesList={this.props.readingValuesList}
                                partitionList={this.props.partitionName}
                                sourceChangeHandler={(
                                    value,
                                    index,
                                    i,
                                    calculatedId
                                ) =>
                                    this.props.onSourceChangeHandler(
                                        value,
                                        index,
                                        i,
                                        calculatedId
                                    )
                                }
                                valuesChangeHandler={(
                                    value,
                                    index,
                                    i,
                                    calculatedId
                                ) =>
                                    this.props.onValuesChangeHandler(
                                        value,
                                        index,
                                        i,
                                        calculatedId
                                    )
                                }
                                partitionChangeHandler={(
                                    value,
                                    index,
                                    i,
                                    calculatedId,
                                    selectedElement
                                ) =>
                                    this.props.onPartitionChangeHandler(
                                        value,
                                        index,
                                        i,
                                        calculatedId,
                                        selectedElement
                                    )
                                }
                                disableValueDropdown={this.props.disableValueDropdown}
                                disablePositionDropdown={
                                    this.props.disablePositionDropdown
                                }
                                disableSourceDropdown={
                                    this.props.disableSourceDropdown
                                }
                                onEditPartitionChange={(
                                    value,
                                    index,
                                    i,
                                    calculatedId
                                ) =>
                                    this.props.onEditPartitionChange(
                                        value,
                                        index,
                                        i,
                                        calculatedId
                                    )
                                }
                                componentType={this.props.componentType}
                                instrumentPartitions={this.props.instrumentPartitions}
                                keyedInPartitions={this.props.keyedInPartitions}
                                measuredProperty={this.props.measuredProperty}
                            />
                            {this.props.showGrade && (<React.Fragment><hr className="hr-line" />
                            <div className="float-right mt-3 pb-3">
                                <Button
                                    type="primary-blue"
                                    icon="abb/left"
                                    text={t(CONSTANTS.BUTTON_BACK)}
                                    onClick={this.props.thresholdvalue}
                                />
                            </div>
                            <div className="clearfix" /></React.Fragment>)}
                        </div>
                    </React.Fragment>
                )
                }
            </Translation>
        );
    }
}
